import * as React from 'react'

export function Twitter(props: React.SVGProps<SVGSVGElement>) {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M22.265 6.277a8.38 8.38 0 0 1-2.419.663 4.219 4.219 0 0 0 1.852-2.33 8.43 8.43 0 0 1-2.674 1.023 4.212 4.212 0 0 0-7.176 3.841 11.958 11.958 0 0 1-8.681-4.4 4.19 4.19 0 0 0-.57 2.117 4.21 4.21 0 0 0 1.873 3.506 4.2 4.2 0 0 1-1.908-.527v.053a4.215 4.215 0 0 0 3.379 4.13 4.236 4.236 0 0 1-1.903.071 4.216 4.216 0 0 0 3.934 2.925 8.449 8.449 0 0 1-6.235 1.744 11.918 11.918 0 0 0 6.456 1.892c7.747 0 11.983-6.417 11.983-11.983 0-.182-.004-.364-.012-.545a8.529 8.529 0 0 0 2.101-2.18z"
                fill="currentColor"
            />
        </svg>
    )
}
